/**
 * Review Carousel (Blue) - JavaScript
 * Handles testimonial carousel navigation and display
 */

const reviewsBlue = [
  {
    statement: "\"A year later, I'm still taking them, and plan to continue. I suggested that a couple of older friends in their 70s try it, and both noticed immediate improvements, and continue to take them. I think they benefit everyone, but the older you are, the more visible the benefit is.\"",
    name: "Carl R.",
    lengthBadge: "Taking NAD3 For 1 Year",
    benefitTags: ["Reduced Accelerated Aging", "Improved Vitality", "Enhanced Cognitive Function"]
  },
  {
    statement: "\"I've been taking NAD for about two years now. I'm a nearly 70 year old male that most people gauge as being mid-50s to 60 years old. Is it the secret? I don't know but I like where I am and will continue to take it.\"",
    name: "Svede",
    lengthBadge: "Taking NAD3 For 2 Years",
    benefitTags: ["Youthful Vitality", "Reduced Accelerated Aging", "Long-Term Wellness"]
  },
  {
    statement: "\"I started this supplement two years ago based upon the science I read was behind its design. The scientific background I believe comes from leading cell biologists who study cellular aging. Since using it I have noticed higher levels of energy in my gym workouts.\"",
    name: "Rasputin",
    lengthBadge: "Taking NAD3 For 2 Years",
    benefitTags: ["Increased Energy Levels", "Backed by Science", "Enhanced Workout Performance"]
  },
  {
    statement: "\"I have been taking this NAD for 2 years now, and I have not used my cane since the second week after I started this supplement. I am an 88 year old obese diabetic with congestive heart failure, arthritis, chronic leukemia, etc. I do not use a cane or a walker, have 20-25 vision and continue to have a great life.\"",
    name: "Hiphoptwo",
    lengthBadge: "Taking NAD3 For 2 Years",
    benefitTags: ["Improved Mobility", "Increased Vision Clarity", "Better Life Quality"]
  },
  {
    statement: "\"Used this for over a year!  This helped me feel better, then I started walking at lunch and I felt even better, then I improved my diet and felt better and I kept going.\"",
    name: "Jeff",
    lengthBadge: "Taking NAD3 For 1 Year",
    benefitTags: ["Sustained Energy Boost", "Encourages Active Lifestyle", "Enhanced Well-Being"]
  },
  {
    statement: "\"For this order, I purchased two bottles for my parents. They are both over 70 and have felt rejuvenated after taking this supplement for months. My father stopped losing his hair and started to grow back in his bald spots. My mom felt more energetic and better memory.\"",
    name: "Weisi L.",
    lengthBadge: "Taking NAD3 For Several Months",
    benefitTags: ["Hair Growth", "Increased Energy", "Improved Memory"]
  },
  {
    statement: "\"I have been taking this since August. I went off for awhile to see if I felt any difference. I came back after off for just a short while. I have moved it into a 'staple' category of my supplements at least for now. I think it gives me energy and the brain power I was seeking. Hopefully it is counteracting my stress level which is high due to a marriage relationship problem.\"",
    name: "Sunshine",
    lengthBadge: "Taking NAD3 For 4 Months",
    benefitTags: ["Increased Mental Clarity", "Sustained Energy Boost", "Stress Resilience"]
  },
  {
    statement: "\"I find that this product really does deliver great metabolic restoration. Probably 2 weeks into the cycle there is an obvious effect, but then after 3 months I observed that my energy floor was higher. Did not feel as tired after workouts, decent sleep.\"",
    name: "J. Gorny",
    lengthBadge: "Taking NAD3 For 3 Months",
    benefitTags: ["Metabolic Restoration", "Increased Energy Levels", "Improved Workout Recovery", "Better Sleep Quality"]
  }
];

let currentReviewIndexBlue = 0;

function displayReviewBlue(index) {
  const statementEl = document.querySelector(".lt-review-statement-blue");
  const nameEl = document.querySelector(".lt-user-name-blue");
  const badgeEl = document.querySelector(".lt-length-badge-blue");
  const tagsContainer = document.querySelector(".lt-benefit-tags-blue");

  if (!statementEl || !nameEl || !badgeEl || !tagsContainer) {
    console.warn("Review carousel elements not found");
    return;
  }

  statementEl.textContent = reviewsBlue[index].statement;
  nameEl.textContent = reviewsBlue[index].name;
  badgeEl.textContent = reviewsBlue[index].lengthBadge;

  tagsContainer.innerHTML = "";
  reviewsBlue[index].benefitTags.forEach(tag => {
    const el = document.createElement("span");
    el.classList.add("lt-benefit-tag-blue");
    el.textContent = tag;
    tagsContainer.appendChild(el);
  });
}

function showPreviousReviewBlue() {
  currentReviewIndexBlue = (currentReviewIndexBlue - 1 + reviewsBlue.length) % reviewsBlue.length;
  displayReviewBlue(currentReviewIndexBlue);
}

function showNextReviewBlue() {
  currentReviewIndexBlue = (currentReviewIndexBlue + 1) % reviewsBlue.length;
  displayReviewBlue(currentReviewIndexBlue);
}

// Initialize carousel when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    displayReviewBlue(currentReviewIndexBlue);
  });
} else {
  // DOM already loaded
  displayReviewBlue(currentReviewIndexBlue);
}
